import { useTranslation } from '@/i18n';
import { useNotification } from '@moneyforward/ap-frontend-components';
import { FC, memo, useEffect } from 'react';

export type ErrorFallbackProps = {
  error: Error | null;
};

export const ErrorFallback: FC<ErrorFallbackProps> = memo(({ error }) => {
  const { t } = useTranslation();
  const notify = useNotification();

  useEffect(() => {
    notify.error({
      title: error?.message ?? t('system_error'),
      opts: {
        duration: 3000,
        style: {
          position: 'fixed',
        },
      },
    });
  }, [error, notify, t]);

  return null;
});
ErrorFallback.displayName = 'ErrorFallback';
